import React, { useState, useEffect } from 'react'
import axios from 'axios'
import i18n from '../i18n'
import CustomSelect from '../components/CustomSelect'
import ArrayToOptions from '../components/ArrayToOptions'

export default function CountryField(props) {
  const {
    updateInputState,
    country,
    errors,
    control,
    label,
    fieldName,
    placeholder,
    fieldId,

    /**
     * Will help parent components to store the fetched countries and avoid unnecessary fetches
     */
    onCountriesFetched,
  } = props

  const [countriesOptions, setCountriesOptions] = useState(
    props.countriesOptions || []
  )

  const brCountry = { label: 'Brasil', value: 'BR' }

  useEffect(() => {
    if (i18n.language === 'pt-BR') {
      updateInputState({
        target: {
          name: 'country',
          value: brCountry,
        },
      })
    } else {
      !countriesOptions?.length && fetchCountries()
    }
  }, [])

  const fetchCountries = async () => {
    return await axios
      .get('/api/v1/countries/list.json', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      .then((response) => {
        let countries = ArrayToOptions(response.data, 'code', 'name')

        // Sort countries to keep 'BR' and 'US' at the top
        countries = countries.sort((a, b) => {
          if (a.value === 'BR' || a.value === 'US') return -1
          if (b.value === 'BR' || b.value === 'US') return 1
        })

        setCountriesOptions(countries)
        onCountriesFetched(countries)
      })
      .catch((error) => console.log(error))
  }

  if (i18n.language === 'pt-BR') return false

  return (
    <div className="form-group">
      <label htmlFor="country-field">{label}</label>
      <CustomSelect
        name={fieldName}
        value={country}
        defaultValue={country}
        options={countriesOptions}
        control={control}
        errors={errors}
        id={fieldId}
        placeholder={placeholder}
        onChange={(selected) => {
          if (!selected) return null

          updateInputState({
            target: {
              name: 'country',
              value: {
                label: selected[0].label,
                value: selected[0].value,
              },
            },
          })

          return selected
        }}
      />
    </div>
  )
}
